import { Injectable, OnDestroy } from '@angular/core';
import { driver } from 'driver.js';

export interface TourStep {
  id: string;
  title: string;
  text: string;
  element: string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end';
  onNext?: () => void;
  onPrevious?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class TourService implements OnDestroy {
  private driverObj: any = null;

  constructor() { }

  initTour(steps: TourStep[], options: any = {}): any {

    const defaultOptions = {
      animate: true,
      opacity: 0.5,
      padding: 10,
      allowClose: true,
      overlayClickNext: false,
      doneBtnText: 'Finish',
      closeBtnText: 'Close',
      nextBtnText: 'Next',
      prevBtnText: 'Previous',
      showButtons: ['next', 'previous', 'close'],
      ...options
    };

    const driverSteps = steps.map((step, index) => {
      const element = document.querySelector(step.element);

      // if (!element) {
      //   console.warn(`⚠️ Element not found for step "${step.id}": ${step.element}`);
      // } else {
      //   console.log(`✅ Element found for step "${step.id}": ${step.element}`);
      // }

      return {
        element: step.element,
        popover: {
          title: step.title,
          description: step.text,
          position: step.position || 'bottom'
        },
        onNext: step.onNext,
        onPrevious: step.onPrevious
      };
    });


    this.driverObj = driver({
      ...defaultOptions,
      steps: driverSteps
    });

    return this.driverObj;
  }

  start(): void {
    if (this.driverObj) {
      this.driverObj.drive();
    } else {
      console.error('❌ Driver object is null! Tour not initialized properly.');
    }
  }

  stop(): void {
    if (this.driverObj) {
      this.driverObj.destroy();
    }
  }

  isActive(): boolean {
    return this.driverObj && this.driverObj.isActivated;
  }

  getDriver(): any {
    return this.driverObj;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
